const mutations = {
    SET_ERROR_API_KEYS(state, payload) {
        state.error = payload;
    },
    SET_API_KEY_PERMISSION_CATALOG(state, { data, expiredAt, tenantId }) {
        state.permissionCatalog = { data, tenantId, expiredAt };
    }
};

export default mutations;
